var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b',[_vm._v(_vm._s(_vm.field.name || _vm.condition.field))])])
}
var staticRenderFns = []

export { render, staticRenderFns }